import classNames from 'classnames'
import { observer } from 'mobx-react'
import React, { FC, useRef, useState, TouchEvent } from 'react'
import styles from './CustomerEntry.module.less'
import { useScrolling } from 'react-use'
import { commonUtils } from '@/helpers/commonUtils'
import { uiController } from '@/controllers/uiController'
// import { userService } from '@/services/userService/userService'
interface CustomerEntryProps {}

const CustomerEntry: FC<CustomerEntryProps> = observer((props: CustomerEntryProps) => {
  const scrollRef = useRef(document.body)
  const scrolling = useScrolling(scrollRef)

  // 添加位置状态
  const [position, setPosition] = useState({
    top: 'auto',
    bottom: '40px',
    left: 'auto',
    right: '6px',
  })
  const [isDragging, setIsDragging] = useState(false)
  // const [startPosition, setStartPosition] = useState({ x: 0, y: 0 })

  // 处理触摸开始事件
  const handleTouchStart = (e: TouchEvent) => {
    setIsDragging(true)
    // setStartPosition({
    //   x: e.touches[0].clientX,
    //   y: e.touches[0].clientY,
    // })
  }

  // 处理触摸移动事件
  const handleTouchMove = (e: TouchEvent) => {
    if (!isDragging) return

    // 只允许垂直方向拖动，保持水平位置不变
    const newTop = `${e.touches[0].clientY - 19}px` // 19px是组件高度的一半，使触摸点在中心

    setPosition({
      top: newTop,
      bottom: 'auto',
      left: 'auto',
      right: '6px',
    })
  }

  // 处理触摸结束事件
  const handleTouchEnd = (e: TouchEvent) => {
    setIsDragging(false)
  }

  // 处理点击事件，只在非拖动状态下触发
  const handleClick = () => {
    if (!isDragging) {
      uiController.contactPopupProps.visible = true
      // userService.openCustomerService()
    }
  }

  return (
    <div
      className={classNames(styles.customerEntry, {
        [styles.opacity]: scrolling,
      })}
      style={position}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <img src={commonUtils.getStaticFile('icon__customer.png')} alt='icon__customer' />
    </div>
  )
})

export default CustomerEntry
